






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as Common from "@/agiles/common";
import ResizeObserver from "resize-observer-polyfill";

@Component
export default class Tab extends Vue {
  @Prop({ default: () => new Array() }) public tabs?: Array<string>;
  @Prop({ default: () => new Array() }) public visibles?: Array<boolean>;
  @Prop({ default: () => new Array() }) public invalids?: Array<boolean>;
  @Prop({ default: () => new Array() }) public tooltips?: Array<string>;  
  @Prop({default: 200}) public scrollWidth:number;
  @Prop({ default: null }) public svg: string;  //基本情報のアイコン表示用

  public currentId: number = 0;
    
  public get tabElements() :HTMLElement[] {
    return Object.keys(this.$refs).filter(key => key.startsWith('tabEL')).map(key=>this.$refs[key] as HTMLElement).flat() ;   
  }
  @Watch("visibles")
  public onVisibleChanged(newValue:any, oldValue:any) {
    //未設定の配列が再度pushされる場合がある
    if(this.visibles.length ==0) this.tabs.forEach(text => this.visibles.push(true));
    //表示タブを決定する
    if (this.visibles[this.currentId] == false || this.currentId == -1) {
      let temp = -1;
      this.visibles.forEach((value, index) => {
        if (value && temp == -1) temp = index;
      });
      this.currentId = temp;
    }
  }

  public created() {
    // if (this.tabs && this.visibles==null){
    //   // this.visibles = new Array();
    //   this.tabs.forEach(text=> this.visibles.push(true));
    // }
    if(this.visibles.length ==0) this.tabs.forEach(text => this.visibles.push(true));
    if(this.invalids.length ==0) this.tabs.forEach(text => this.invalids.push(false));    
    if(this.tooltips.length ==0) this.tabs.forEach(text => this.tooltips.push(null));
  }
  public mounted(){
    let observer = new ResizeObserver(this.onSizeChanged);    
    observer.observe(this.$refs.tab as HTMLElement);        
    this.onClick(0);
  }

  public tabIsOverflown:boolean = false;
  public onSizeChanged(){
    var target = this.$refs.tab as HTMLElement;  
    if (target && target.scrollWidth > target.clientWidth) this.tabIsOverflown = true;
    else this.tabIsOverflown = false;
  }
   intervalId:any = null;
   public scrollStart(direction:string){
     if (direction == 'left') this.intervalId = setInterval(this.scrollLeft,100);
     else if (direction == 'right') this.intervalId = setInterval(this.scrollRight,100);
   }
   public scrollEnd(){
     if (this.intervalId) clearInterval(this.intervalId);
   }
   public scrollLeft(){
    var target = this.$refs.tab_outer as HTMLElement;
    target.scrollTo(target.scrollLeft-20,0);
  }
  public scrollRight(){
    var target = this.$refs.tab_outer as HTMLElement;    
    target.scrollTo(target.scrollLeft+20,0);
  }
  public onClick(index: number) {
    this.currentId = index;
    this.$nextTick(()=>{
      if(this.tooltips[index]) this.$api.tooltip.mount(this, (this.$refs.tooltip_target as Element[])[0],this.tooltips[index]);
    });
  }
}
